














































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { getId, getRouteName, setRouteName } from "@/config/cookies";
import { today, yestoday, nowMonth, lastMonth } from "@/config/utils";
import { orderReport, getFacList } from "@/api/car";
import { getOrderReport } from "@/api/interface";
import $ from "jquery";
import dayjs from "dayjs";
@Component
export default class extends Vue {
  private orderType: string = "sale";
  private selectFac: string = "";
  private fac_id: number = 1;
  private beginTime: string = "";
  private endTime: string = "";
  private create_time: string = "";
  private showPicker: boolean = false;
  private isTimeShow: boolean = false;
  private timeType: string = "";
  private currentDate: Date = new Date();
  private columns: any = [];
  private lastQucikSelect: number = 0;
  private quickSelect: number = 0;
  private sellData: Array<object> = [];
  private purData: Array<object> = [];
  private orderData: Array<object> = [];

  private onConfirm(val: any) {
    this.selectFac = val.fac_name;
    this.fac_id = val.factory_id;
    this.showPicker = false;
    if (this.quickSelect != 0) {
      this.quickSubmit();
    }
  }
  private confirmBeginPicker(val: any) {
    let date: string = dayjs(val).format("YYYY-MM-DD HH:mm");
    if (this.timeType == "begin") {
      this.beginTime = date;
    } else {
      this.endTime = date;
    }
    this.isTimeShow = false;
  }
  private submit() {
    if (this.selectFac && this.beginTime && this.endTime) {
      this.getReport(this.beginTime + " - " + this.endTime);
    } else {
      this.$notify({ type: "warning", message: "请选择厂区和开始结束时间" });
    }
  }
  @Watch("quickSelect", { immediate: true })
  private quickSubmit() {
    if (this.quickSelect == 0) return;
    if (this.quickSelect == this.lastQucikSelect) {
      this.quickSelect = 0;
      return;
    }
    this.lastQucikSelect == this.quickSelect;
    if (this.selectFac) {
      let time: string = "";
      switch (this.quickSelect) {
        case 1:
          time = today();
          break;
        case 2:
          time = yestoday();
          break;
        case 3:
          time = nowMonth();
          break;
        case 4:
          time = lastMonth();
          break;
      }
      this.getReport(time);
    } else {
      this.$notify({ type: "warning", message: "请选择厂区" });
    }
  }

  @Watch("orderType", { immediate: true })
  private setOrderData() {
    if (this.orderType == "sale") {
      this.orderData = this.sellData;
    } else {
      this.orderData = this.purData;
    }
  }

  private mounted() {
    const name = (this.$route as any).name;
    // setRouteName(name);
    this.getFacList();
  }
  private async getReport(time: string) {
    this.create_time = time;
    let form: getOrderReport = {
      openId: getId(),
      factory_id: this.fac_id,
      create_time: time,
    };
    let res: any = await orderReport(form);
    if (res.status) {
      this.sellData = res.data.returnData.sellReport;
      this.purData = res.data.returnData.purReport;
      this.orderData = this.sellData;
    } else {
      this.$notify({ type: "danger", message: res.info });
    }
  }
  private async getFacList() {
    let res: any = await getFacList();
    if (res.status) {
      this.columns = res.data;
      this.selectFac = res.data[0].fac_name;
      this.fac_id = res.data[0].factory_id;
    } else {
      this.$notify({ type: "danger", message: res.info });
    }
  }
}
